var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clickable font--s14 font--w700 accentButton flex flex--center",class:{
    'accentButton--filled': _vm.filled,
    'accentButton--light': _vm.light,
    'width--100': _vm.fullWidth,
    'accentButton--disabled': _vm.disabled,
  },on:{"click":function($event){_vm.disabled ? null : _vm.$emit('onClick')}}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(!this.loading)?_c('div',{key:"title",staticClass:"noDec"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_c('div',{key:"loader",staticClass:"absolutes"},[_c('loader',{attrs:{"loading":true,"color":_vm.filled ? '#fff' : '#114B5F',"size":'10px'}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }